import { render, staticRenderFns } from "./NotificationCard.html?vue&type=template&id=452e4bb4&scoped=true&external"
import script from "./NotificationCard.vue?vue&type=script&lang=js"
export * from "./NotificationCard.vue?vue&type=script&lang=js"
import style0 from "./NotificationCard.scss?vue&type=style&index=0&id=452e4bb4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452e4bb4",
  null
  
)

export default component.exports